// Loading.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader } from './layout/Loader';

export const Loading = ({ dataSource, children }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (Array.isArray(dataSource)) {
        const item = dataSource.find(item => item.id === id);
        if (item) {
          setData(item);
          setLoading(false);
        } else {
          navigate("/error", { replace: true });
        }
      } else {
        console.error("dataSource is not an array:", dataSource);
        navigate("/error", { replace: true });
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [id, dataSource, navigate]);

  if (loading) return <Loader />;

  return React.cloneElement(children, { data });
};
